import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type MessageTopicsQueryVariables = Types.Exact<{ [key: string]: never }>

export type MessageTopicsQuery = {
  __typename?: 'Query'
  messageTopics: Array<{ __typename?: 'Topic'; id: number; name: string }>
}

export const MessageTopicsDocument = gql`
  query MessageTopics {
    messageTopics {
      id
      name
    }
  }
`
export function useMessageTopicsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<MessageTopicsQuery, MessageTopicsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<MessageTopicsQuery, MessageTopicsQueryVariables>(
    MessageTopicsDocument,
    options
  )
}
export function useMessageTopicsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MessageTopicsQuery,
    MessageTopicsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<MessageTopicsQuery, MessageTopicsQueryVariables>(
    MessageTopicsDocument,
    options
  )
}
export type MessageTopicsQueryHookResult = ReturnType<typeof useMessageTopicsQuery>
export type MessageTopicsLazyQueryHookResult = ReturnType<typeof useMessageTopicsLazyQuery>
export type MessageTopicsQueryResult = ApolloReactCommon.QueryResult<
  MessageTopicsQuery,
  MessageTopicsQueryVariables
>
export function refetchMessageTopicsQuery(variables?: MessageTopicsQueryVariables) {
  return { query: MessageTopicsDocument, variables: variables }
}
